
import { TSX, Component, Prop } from 'vue-facing-decorator'
import { ListViewVue } from '@/common/BaseVue'
import {
  getCouponTypeName as couponTypeName,
  getCouponContent as couponContent,
  getCouponStock as couponStock,
} from '@/common/coupon'

interface Props {
  /** 本次要发放的人数，用来和券的剩余库存比对 */
  userCount: number
}

@Component({})
export default class extends TSX<Props>()(ListViewVue) implements Props {
  @Prop({ default: 0 })
  userCount: number;

  /** 类组件只有类成员能在模板里访问，模块级 import 要挂到实例上 */
  getCouponTypeName = couponTypeName;
  getCouponContent = couponContent;
  getCouponStock = couponStock;

  selectedCoupon: any = null;

  get checkedId() {
    return this.selectedCoupon ? this.selectedCoupon.id : null;
  }

  get stockTip() {
    if (!this.selectedCoupon) {
      return `请选择要赠送的优惠券，本次共 ${this.userCount} 人`;
    }
    return `该券剩余 ${this.getCouponStock(this.selectedCoupon)} 张，本次赠送 ${this.userCount} 张`;
  }

  get stockError() {
    if (!this.selectedCoupon) return "";
    if (this.getCouponStock(this.selectedCoupon) < this.userCount) {
      return `库存不足：该券剩余 ${this.getCouponStock(this.selectedCoupon)} 张，本次需要 ${this.userCount} 张`;
    }
    return "";
  }

  toggle(row) {
    if (row.status != 1) return;
    this.selectedCoupon = row;
  }

  choose() {
    if (!this.selectedCoupon) {
      return this.$error("请选择优惠券");
    }
    if (this.stockError) {
      return this.$error(this.stockError);
    }
    this.$emit("resolve", this.selectedCoupon);
  }

  cancelEvent() {
    this.$emit("reject", { msg: "取消" });
  }

  /** 列表接口只支持分页、没有名称筛选，所以这里不做搜索框 */
  getList() {
    return this.$post("/manager/coupon/list", this.mesureData);
  }
}
